import React from 'react';
export function Intro() {
  return <section className="max-w-[640px] mx-auto px-4 py-8 text-lg text-slate-800 leading-relaxed space-y-6" data-id="element-26">
      <p data-id="element-27">
        Bis die meisten Frauen Ende vierzig sind, haben sie — vorsichtig
        geschätzt — zwischen 800 und 2.400 Euro für Augencremes ausgegeben, die
        nichts gebracht haben.
      </p>
      <p data-id="element-28">Manche haben deutlich mehr ausgegeben.</p>
      <p data-id="element-29">
        Wenn Sie das hier lesen, kommt Ihnen die Zahl wahrscheinlich bekannt
        vor. Sie kennen den Ablauf: Ein neuer Tiegel kommt, die Verpackung ist
        schön, die Inhaltsstoffliste klingt beeindruckend, Sie tragen die Creme
        sechs Wochen lang morgens und abends auf — und eines Morgens stehen Sie
        vor dem Spiegel und können sich nicht mehr erinnern, ob sie überhaupt
        etwas gebracht hat. Weil sich tatsächlich nichts verändert hat.
      </p>
      <p data-id="element-30">Was jetzt folgt, ist keine Empfehlung für eine weitere Creme.</p>
      <p data-id="element-31">
        Es ist eine Erklärung. Gestützt auf Erkenntnisse der deutschen
        Verbraucherschutz-Institutionen, auf die ästhetische Praxis in
        Österreich und der Schweiz und auf ein Stück europäische
        Medizingeschichte, das fast niemand unter sechzig noch kennt. Eine
        Erklärung dafür, warum nichts von dem, was Sie ausprobiert haben,
        gewirkt hat — und was eine kleine Gruppe von Ärztinnen in München, Wien
        und Zürich stattdessen empfiehlt.
      </p>
      <p className="font-medium text-slate-900 bg-brand-50 p-6 rounded-xl border border-brand-100" data-id="element-32">
        Die fünf Wahrheiten unten sind in der Reihenfolge angeordnet, in der Sie
        sie verstehen müssen. Wenn Sie nur die ersten drei lesen, wissen Sie
        immerhin, warum Ihr Geld verschwendet war. Wenn Sie alle fünf lesen,
        wissen Sie, was Sie jetzt tun können.
      </p>
    </section>;
}